import { host, logoUrl, paths } from '@natu/utils/paths';

import { SBProps } from '../../../../utils';
import { ArticleNodeAuthor } from '../../../../utils/src/types/Blog/ArticleNode.types';

type SBWebpageJsonLdProps = {
  isArticle?: boolean;
  name?: string;
  headline?: string;
  description?: string;
  parentProps?: {
    firstPublishedAt?: string;
    updatedAt?: string;
    slug?: string;
    title?: string;
    description?: string;
    author?: ArticleNodeAuthor;
    previewImage?: string;
    authorImage?: string;
  };
};

export const SBWebpageJsonLd = ({ blok }: SBProps<SBWebpageJsonLdProps>) => {
  const { isArticle, description, headline, name, parentProps } = blok;

  const pageUrl = parentProps?.slug ? `${host}/${parentProps.slug}` : host;

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': pageUrl,
    url: pageUrl,
    name: name || '',
    headline: headline || name || '',
    description: description || '',
    datePublished: parentProps?.firstPublishedAt || new Date().toISOString(),
    dateModified: parentProps?.updatedAt || new Date().toISOString(),
    inLanguage: 'en',
    publisher: {
      '@type': 'Organization',
      name: 'Naturaily',
      url: host,
      logo: {
        '@type': 'ImageObject',
        url: logoUrl,
      },
    },
    ...(isArticle && {
      mainEntity: {
        '@type': 'Article',
        url: `${host}/${parentProps?.slug}`,
        headline: parentProps?.title || '',
        description: parentProps?.description || parentProps?.title || '',
        image: parentProps?.previewImage ? [parentProps.previewImage] : [],
        datePublished: parentProps?.firstPublishedAt || new Date().toISOString(),
        isAccessibleForFree: true,
        author: parentProps?.author
          ? {
              '@type': 'Person',
              name: parentProps.author.name || '',
              url: `${host}${paths.blog}${paths.authors}/${parentProps.author.slug}`,
              ...(parentProps.authorImage && { image: parentProps.authorImage }),
            }
          : {},
        publisher: {
          '@type': 'Organization',
          name: 'Naturaily',
          logo: {
            '@type': 'ImageObject',
            url: logoUrl,
          },
        },
      },
    }),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
    />
  );
};
